import { defineMessages } from 'react-intl';

export default defineMessages({
  invoice: 'Plik faktury VAT',
  addTitle: 'Dodaj fakturę VAT',
  editTitle: 'Edytuj fakturę VAT',
  viewTitle: 'Faktura VAT',
});
